import { types, flow } from "mobx-state-tree";
import fetcher from "../utils/fetcher";
import userStore from "./userStore";
import { getErrorMessage } from "../utils/helper";

const ReportDetailsStore = types
  .model("ReportDetailsStore", {
    error: types.frozen(),
    reportDetails: types.frozen(),
    customerTasks: types.frozen(),
    customerCalls: types.frozen(),
    selectedReportDetail: types.frozen(),
  })
  .actions((self) => {
    const getReportDetails = flow(function* getReportDetails(data) {
      self.setError("");
      setReportDetails([]);
      const reports = yield fetcher()
        .post(data)
        .from.report_details.get_user_report_details();
      if (reports.status === 200 && reports.data) {
        self.setReportDetails(reports.data || []);
      } else {
        console.log("error_failed_get_report_details_req");

        const errorText = "error:error_failed_get_report_details_req";
        self.setError(getErrorMessage(reports, errorText));
      }
    });

    const getTasksByCustomer = flow(function* getTasksByCustomer(data) {
      self.setError("");
      setTasksByCustomer([]);
      const tasks = yield fetcher()
        .post(data)
        .from.report_details.get_tasks_by_customer();

      if (tasks.status === 200 && tasks.data) {
        self.setTasksByCustomer(tasks.data || []);
      } else {
        console.log("error_failed_get_tasks_by_customer_req");

        const errorText = "error:error_failed_get_tasks_by_customer_req";
        self.setError(getErrorMessage(tasks, errorText));
      }
    });

    const getCallsByCustomer = flow(function* getCallsByCustomer(data) {
      self.setError("");
      setCallsByCustomer([]);
      const calls = yield fetcher()
        .post(data)
        .from.report_details.get_calls_by_customer();

      if (calls.status === 200 && calls.data) {
        self.setCallsByCustomer(calls.data || []);
      } else {
        console.log("error_failed_get_calls_by_customer_req");

        const errorText = "error:error_failed_get_calls_by_customers_req";
        self.setError(getErrorMessage(calls, errorText));
      }
    });

    const addReport = flow(function* addReport(data) {
      self.setError("");
      const response = yield fetcher()
        .post(data)
        .from.report_details.add_report();
      if (response.status === 200 && response.data) {
        yield self.getReportDetails({
          ZCR_USERID: userStore.userDetails.ZCR_USERID,
        });
      } else {
        const errorText = "error:error_failed_add_report_req";
        self.setError(getErrorMessage(response, errorText));
      }
    });

    const updateReport = flow(function* updateReport(data) {
      self.setError("");
      const response = yield fetcher()
        .post(data)
        .from.report_details.update_report();
      if (response.status === 200 && response.data) {
        yield self.getReportDetails({
          ZCR_USERID: userStore.userDetails.ZCR_USERID,
        });
      } else {
        const errorText = "error:error_failed_update_report_req";
        self.setError(getErrorMessage(response, errorText));
      }
    });

    const getReport = flow(function* getReport(data) {
      self.setError("");
      const response = yield fetcher()
        .post(data)
        .from.report_details.get_report();
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        const errorText = "error:error_failed_get_report_req";
        self.setError(getErrorMessage(response, errorText));
      }
    });

    const deleteReport = flow(function* deleteReport(data) {
      self.setError("");
      const response = yield fetcher()
        .post(data)
        .from.report_details.delete_report();
      if (response.status === 200 && response.data) {
        yield self.getReportDetails({
          ZCR_USERID: userStore.userDetails.ZCR_USERID,
        });
      } else {
        const errorText = "error:error_failed_delete_report_req";
        self.setError(getErrorMessage(response, errorText));
      }
    });

    const getQuestions = flow(function* getQuestions(data) {
      self.setError("");
      const response = yield fetcher().get.from.report_details.get_questions();
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        const errorText = "error:error_failed_get_questions";
        self.setError(getErrorMessage(response, errorText));
      }
    });

    function setSelectedReportDetail(selectedReportDetail) {
      self.selectedReportDetail = selectedReportDetail;
    }

    function setError(error) {
      self.error = error;
    }

    function setReportDetails(reports) {
      self.reportDetails = reports;
    }

    function setTasksByCustomer(tasks) {
      self.customerTasks = tasks;
    }

    function setCallsByCustomer(calls) {
      self.customerCalls = calls;
    }

    return {
      getTasksByCustomer,
      getCallsByCustomer,
      getReportDetails,
      setReportDetails,
      setTasksByCustomer,
      setCallsByCustomer,
      addReport,
      updateReport,
      deleteReport,
      getQuestions,
      setError,
      setSelectedReportDetail,
      getReport,
    };
  })
  .views((self) => ({
    get isError() {
      return !!self.error;
    },
  }));

const reportDetailsStore = ReportDetailsStore.create({
  error: "",
  reportDetails: [],
  customerTasks: [],
  customerCalls: [],
  selectedReportDetail: {},
});

export default reportDetailsStore;
